<div class="dashboard-container">
  <!-- Main Content -->
  <div class="main-content">
    <!-- Key Controls Compliance Metrics Section -->
    <section class="dashboard-section">
      <div class="section-header">
        <h1 class="section-title">Key Controls Compliance Metrics</h1>
        <button class="btn-view-more">View more</button>
      </div>

      <div class="section-content">
        <!-- Executive Summary -->
        <div class="form-field">
          <label class="field-label">Executive summary</label>
          <textarea
            class="text-area"
            placeholder="Write summary"
            [(ngModel)]="executiveSummary"
            rows="3"
          >
          </textarea>
        </div>

        <!-- Compliance Metrics Table -->
        <div class="metrics-table">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>DLP</th>
                <th>DA</th>
                <th>Ai</th>
                <th>Transfer</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let metric of complianceMetrics; let i = index"
                [class.even]="i % 2 === 0"
              >
                <td class="category-cell">{{ metric.category }}</td>
                <td class="value-cell">{{ metric.dlp }}</td>
                <td class="progress-cell">
                  <div class="progress-bar">
                    <div
                      class="progress-fill"
                      [style.width]="metric.da + '%'"
                    ></div>
                  </div>
                  <span class="progress-text">{{ metric.da }}%</span>
                </td>
                <td class="value-cell">{{ metric.ai }}</td>
                <td class="progress-cell">
                  <div class="progress-bar">
                    <div
                      class="progress-fill"
                      [style.width]="metric.transfer + '%'"
                    ></div>
                  </div>
                  <span class="progress-text">{{ metric.transfer }}%</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- Key Control Assurance Section -->
    <section class="dashboard-section">
      <div class="section-header">
        <h1 class="section-title">Key Control Assurance</h1>
        <button class="btn-view-more">View more</button>
      </div>

      <div class="section-content">
        <h3 class="subsection-title">Total Controls Tested</h3>

        <div class="controls-tested-container">
          <!-- Stacked Bar Chart -->
          <div class="chart-container">
            <div class="chart-area">
              <canvas
                baseChart
                [data]="controlsChartData"
                [type]="controlsChartType"
                [options]="controlsChartOptions"
              ></canvas>
            </div>
          </div>

          <!-- Legend -->
          <div class="chart-legend">
            <div class="legend-item">
              <div class="legend-color failed"></div>
              <span>Failed</span>
            </div>
            <div class="legend-item">
              <div class="legend-color partially-passed"></div>
              <span>Partially passed</span>
            </div>
            <div class="legend-item">
              <div class="legend-color passed"></div>
              <span>Passed</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Enterprise Level Risks Section -->
    <section class="dashboard-section full-width">
      <div class="section-header">
        <h1 class="section-title">Enterprise Level Risks</h1>
        <button class="btn-view-more">View more</button>
      </div>

      <div class="risks-content">
        <!-- Mitigation Health Table -->
        <div class="mitigation-table">
          <h3 class="subsection-title">Mitigation Health</h3>
          <table class="data-table">
            <thead>
              <tr>
                <th>SET area</th>
                <th>High</th>
                <th>Medium</th>
                <th>Low</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of mitigationHealthData; let i = index"
                [class.even]="i % 2 === 0"
              >
                <td class="category-cell">{{ row.setArea }}</td>
                <td>{{ row.high }}</td>
                <td>{{ row.medium }}</td>
                <td>{{ row.low }}</td>
                <td>{{ row.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Risk Items Table -->
        <div class="risk-items-table">
          <table class="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Score</th>
                <th>RAG</th>
                <th>Description</th>
                <th>Update</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let risk of riskItems; let i = index"
                [class.even]="i % 2 === 0"
              >
                <td class="risk-name">{{ risk.name }}</td>
                <td class="score-cell">
                  <span
                    class="score-badge"
                    [ngClass]="getScoreBadgeClass(risk.scoreType)"
                  >
                    <img
                      class="icon"
                      [src]="getScoreIcon(risk.scoreType)"
                      [alt]="risk.scoreType + ' icon'"
                    />
                    {{ risk.score }}
                  </span>
                </td>
                <td>{{ risk.rag }}</td>
                <td>{{ risk.description }}</td>
                <td>{{ risk.update }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>

  <!-- Right Sidebar - Incident Management -->
  <aside class="right-sidebar">
    <section class="dashboard-section">
      <div class="section-header">
        <h1 class="section-title">Incident Management</h1>
        <button class="btn-view-more">View more</button>
      </div>

      <div class="section-content">
        <!-- Bar Chart -->
        <div class="incident-chart">
          <div class="chart-with-label">
            <div class="y-axis-label-container">
              <span class="y-axis-label">Number of Incidents</span>
            </div>

            <div class="chart-content">
              <div class="chart-area">
                <canvas
                  baseChart
                  [data]="incidentChartData"
                  [type]="incidentChartType"
                  [options]="incidentChartOptions"
                ></canvas>
              </div>
            </div>
          </div>

          <!-- Filters -->
          <div class="filters">
            <div class="filter-field">
              <label>SET area</label>
              <select class="select-field">
                <option>Select option...</option>
              </select>
            </div>
            <div class="filter-field">
              <label>Month</label>
              <select class="select-field">
                <option>Select option...</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Growth Incident Chart -->
    <section class="dashboard-section growth-section">
      <div class="growth-chart">
        <div class="chart-with-label">
          <div class="y-axis-label-container">
            <span class="y-axis-label">Growth Incident</span>
          </div>

          <div class="chart-content">
            <div class="line-chart">
              <canvas
                baseChart
                [data]="growthChartData"
                [type]="growthChartType"
                [options]="growthChartOptions"
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </section>
  </aside>
</div>
